export default __webpack_public_path__ + "static/media/cpv_75_governance.1c14081e.svg";